import { motion } from 'framer-motion'
import { ArrowRight, Zap, Clock, Users, TrendingUp } from 'lucide-react'

const FinalCTA = () => {
  const benefits = [
    {
      icon: Zap,
      title: 'Comece em minutos',
      description: 'Setup simples e intuitivo'
    },
    {
      icon: Clock,
      title: 'Economize tempo',
      description: 'Reduza 80% do tempo de análise'
    },
    {
      icon: Users,
      title: 'Suporte 24/7',
      description: 'Equipe sempre disponível'
    },
    {
      icon: TrendingUp,
      title: 'Resultados comprovados',
      description: 'Milhares de usuários satisfeitos'
    }
  ]

  return (
    <section className="section-padding bg-gradient-to-br from-primary-600 via-primary-700 to-accent-600 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0 bg-gradient-to-br from-white/5 to-white/10"></div>
      </div>

      <div className="container-custom relative z-10">
        <div className="text-center text-white">
          {/* Main CTA */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="mb-12"
          >
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
              Não perca mais tempo{' '}
              <span className="text-accent-300">procurando informações</span>
            </h2>
            <p className="text-xl md:text-2xl text-primary-100 max-w-4xl mx-auto leading-relaxed mb-8">
              Deixe a IA trabalhar por você. Transforme documentos em insights 
              valiosos e tome decisões mais inteligentes em tempo recorde.
            </p>
          </motion.div>

          {/* Benefits Grid */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-12"
          >
            {benefits.map((benefit, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.3 + index * 0.1 }}
                className="text-center"
              >
                <div className="inline-flex items-center justify-center w-16 h-16 bg-white/20 backdrop-blur-sm rounded-2xl mb-4">
                  <benefit.icon className="w-8 h-8 text-white" />
                </div>
                <h3 className="font-semibold text-lg mb-2">{benefit.title}</h3>
                <p className="text-primary-100 text-sm">{benefit.description}</p>
              </motion.div>
            ))}
          </motion.div>

          {/* CTA Buttons */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="flex flex-col sm:flex-row gap-4 justify-center items-center"
          >
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="bg-white text-primary-700 hover:bg-gray-100 font-bold py-4 px-8 rounded-xl text-lg transition-all duration-300 shadow-lg hover:shadow-xl flex items-center space-x-2"
            >
              <span>Começe Agora</span>
              <ArrowRight className="w-6 h-6" />
            </motion.button>
            
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="border-2 border-white text-white hover:bg-white hover:text-primary-700 font-bold py-4 px-8 rounded-xl text-lg transition-all duration-300 flex items-center space-x-2"
            >
              <span>Ver demonstração</span>
              <ArrowRight className="w-6 h-6" />
            </motion.button>
          </motion.div>

          {/* Trust Indicators */}
          {/* <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.6 }}
            className="mt-12 pt-8 border-t border-white/20"
          >
            <p className="text-primary-100 mb-4">Já confiado por:</p>
            <div className="flex flex-wrap justify-center items-center gap-8 text-white/80">
              <div className="text-center">
                <div className="text-2xl font-bold">500+</div>
                <div className="text-sm">Empresas</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold">50k+</div>
                <div className="text-sm">Usuários</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold">1M+</div>
                <div className="text-sm">Documentos</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold">99.9%</div>
                <div className="text-sm">Satisfação</div>
              </div>
            </div>
          </motion.div> */}
        </div>
      </div>
    </section>
  )
}

export default FinalCTA
